// extracted by mini-css-extract-plugin
module.exports = {"Table":"HealthMonitorTable_Table__2FxwW","IconImage":"HealthMonitorTable_IconImage__3qxOw","KendoGrid":"HealthMonitorTable_KendoGrid__3iZ8a"};